import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../Utilis';
import './Header.css';

const allowedEmails = ['dragan@ribarnice.hr', 'projekti@centaurus.hr', 'skladiste@ribarnice.hr', 'riba@centaurus.hr', 'prodaja2@centaurus.hr'];

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user: userProfile } = useContext(UserContext);

  const debounce = (func, delay) => {
    let debounceTimer;
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const adjustPaddingForHeader = useCallback(() => {
    const header = document.querySelector('.sticky-header');
    if (header) {
      const headerHeight = header.offsetHeight;
      const mainContent = document.querySelector('.container');
      if (mainContent) {
        mainContent.style.paddingTop = `${headerHeight}px`;
      }
    }
  }, []);

  useEffect(() => {
    const debouncedAdjustPadding = debounce(adjustPaddingForHeader, 100);
    window.addEventListener('resize', debouncedAdjustPadding);
    adjustPaddingForHeader();

    return () => window.removeEventListener('resize', debouncedAdjustPadding);
  }, [adjustPaddingForHeader]);

  const toggleSidebar = useCallback(() => {
    setSidebarOpen(prevState => !prevState);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    window.location.href = '/';
  }, []);

  const isAuthorized = allowedEmails.includes(userProfile?.email);

  return (
    <>
      <div className="sticky-header">
        <div className="left-section">
          <button className="menu-btn" onClick={toggleSidebar}>
            &#9776;
          </button>
        </div>
        <div className="right-section">
          <div className="logo">
            <a href="https://bluedatab.com/" target="_blank" rel="noopener noreferrer">
              <img src={require('./../../Png/small.webp')} alt="Karmen Studio Logo" />
            </a>
          </div>
        </div>
      </div>
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar}>
          &times;
        </button>
        <div className="avatar-section">
          <Link to="/home">
            <div className="avatar">
              {userProfile && userProfile.avatar ? (
                <img src={`data:image/png;base64,${userProfile.avatar}`} alt="User Avatar" />
              ) : (
                <h3>Avatar</h3>
              )}
            </div>
          </Link>
          <div className="yellow-line-new"></div>
        </div>
        {isAuthorized && (
          <>
            <a href="Inventura" className="black-link">Dnevna inventura</a>
            <p className="section-title">Analitika</p>
            <ul className="sub-menu">
              <li>
                <Link to="/home/tjedni-otpis">Tjedni otpis</Link>
              </li>
              <li>
                <Link to="/home/gap-analiza">Gap analitika</Link>
              </li>
            </ul>
            <a href="Podjela" className="black-link">Podjela Robota</a>

            {/* <p className="section-title">Podjela robot</p>
            <ul className="sub-menu">
              <li>
                <Link to="/home/before">Prije</Link>
              </li>
              <li>
                <Link to="/home/after+-">Poslije</Link>
              </li>
            </ul> */}
            <a href="Nalozi" className="black-link">Keka</a>
          </>
        )}
        <a href="#" className="black-link" onClick={handleLogout}>
          Log out
        </a>
      </div>
      {sidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default Header;
